export const plans = {
  title: "Scegli il tuo piano",
  subtitle: "Prezzo per unità al mese, con sconti per volume. Puoi combinare più tipi di struttura in un unico ordine.",
  typeLabel: "Tipo di struttura",
  types: {
    apartamento: "Appartamenti",
    hotel: "Hotel",
    camping: "Campeggio",
    villa: "Ville",
  },
  units: {
    apartamento: "appartamento | appartamenti",
    hotel: "camera | camere",
    camping: "piazzola | piazzole",
    villa: "villa | ville",
  },
  decrease: "Togli un'unità",
  increase: "Aggiungi un'unità",
  billing: {
    label: "Fatturazione",
    monthly: "Mensile",
    annual: "Annuale",
    annualSave: "−20%",
  },
  perUnit: "/mese per unità",
  totalLine: "{qty} {units} · {total}/mese in totale",
  billedAnnually: "fatturato annualmente",
  add: "Aggiungi all'ordine",
  isNew: "Nuovo",
  pro: {
    badge: "Più popolare",
    tagline: "Tutta la piattaforma: IA, canali, incassi e ricavi.",
    f1: "Check-in online e schedine alloggiati inviate automaticamente alle autorità",
    f2: "Reception IA 24/7 su WhatsApp: risponde, risolve i dubbi e automatizza",
    f3: "Casella unificata (WhatsApp + Booking, Airbnb ed Expedia), traduzione e passaggio a un operatore",
    f4: "Fatturazione elettronica (SdI)",
    f5: "Channel Manager +100 OTA, calendario unificato e gestione dei prezzi (zero overbooking)",
    f6: "Prenotazioni dirette con il tuo sito web, senza commissioni",
    f7: "Serrature intelligenti con codici di accesso automatici",
    f8: "Extra e upselling, estensione del soggiorno e promozioni",
    f9: "Incassi e pagamenti con acconti",
    f10: "Pulizie e team, con ruoli e accessi",
    f11: "Multiproprietà, analisi e report per proprietario",
  },
  suite: {
    badge: "Tutto incluso",
    tagline: "Il piano più completo: reception telefonica con IA, il tuo sito web e prezzi dinamici.",
    lead: "Tutto ciò che c'è in Pro, e in più:",
    s1: "Numero dedicato per WhatsApp e chiamate",
    s2: "Reception IA telefonica: risponde al telefono 24/7 nella lingua dell'ospite",
    s3: "Chiamate in entrata: 40 min/mese inclusi",
    s4: "WebBuilder: il tuo sito web completo",
    s5: "Prezzi dinamici: regolazione automatica delle tariffe",
    s6: "Più entità di fatturazione da associare a ciascuna struttura",
  },
  cart: {
    title: "Il tuo ordine",
    empty: "Scegli il tipo di struttura e le unità, poi aggiungi un piano.",
    plan: "Piano {plan}",
    remove: "Rimuovi",
    monthlyTotal: "Totale al mese",
    annualTotal: "Fatturato all'anno: {total}",
    planSwitched: "Un ordine ha un solo piano: ora è tutto {plan}.",
    welcomeTitle: "Sconto invito applicato",
    welcomeMonthly: "{percent}% di sconto sui primi {months} mesi: {total}/mese",
    welcomeAnnual: "Risparmi {amount} sulla prima fattura annuale",
    pay: "Continua al pagamento",
    paying: "Apertura del pagamento…",
    taxes: "Tasse escluse. Stripe ti chiederà i dati di fatturazione.",
    error: "Non è stato possibile aprire il pagamento. Riprova.",
  },
  payment: {
    success: "Pagamento ricevuto. Il tuo piano sarà attivo tra pochi secondi.",
    failed: "Il pagamento non è stato completato. Puoi riprovare quando vuoi.",
    active: "Fatto! Il tuo piano è attivo.",
  },
  active: {
    includes: "Cosa include il tuo piano",
    discount: "Sconto invito: {percent}% fino al {date}",
    discountAnnual: "Sconto invito applicato alla tua prima fattura",
    referralCredit: "Hai {amount} di credito per aver invitato altri host: verrà scalato dalla tua prossima fattura.",
  },
};
